import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {DataPortalAdministrationTabs} from '../../shared/types/nso-data-portal/data-portal-administration-tabs';
import {Subscription} from 'rxjs';

@Component({
  selector: 'wsd-administration-data-portal',
  templateUrl: './administration-data-portal.component.html',
  styleUrls: ['./administration-data-portal.component.css']
})
export class AdministrationDataPortalComponent implements OnInit, OnDestroy {

  selectedTab: DataPortalAdministrationTabs = DataPortalAdministrationTabs.CENSUS;

  tabTypes = DataPortalAdministrationTabs;

  private routeSub: Subscription;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.routeSub = this.route.params.subscribe(
      (params: Params) => this.goToSubStep(params['stepId'])
    );
  }

  private goToSubStep = (tab: DataPortalAdministrationTabs) => this.selectedTab = tab;

  ngOnDestroy(): void {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }
}
